import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2ede212e&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "@/pages/assetManagement/common/style/workWechat.scss?vue&type=style&index=0&id=2ede212e&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede212e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ede212e')) {
      api.createRecord('2ede212e', component.options)
    } else {
      api.reload('2ede212e', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=2ede212e&scoped=true", function () {
      api.rerender('2ede212e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/workWechat/add.vue"
export default component.exports